(window as any)['__zone_symbol__PASSIVE_EVENTS'] = ['scroll', 'touchstart'];